import { Component } from '@angular/core';
import { FeatureFlag } from '../../../models/admin/featureFlag';
import { AdminService } from '../../../models/admin/adminService';
import { MatDialog } from '@angular/material/dialog';
import { SimpleDialogComponent, SimpleDialogData } from '../../../../../../../libs/Shared/components/dialogs/simple-dialog.component';

@Component({
  selector: 'app-feature-flags',
  templateUrl: './feature-flags.component.html',
  standalone: false,
})
export class FeatureFlagsComponent {
  loading: boolean = false;
  newFeatureFlagName: string | undefined;
  featureFlags: FeatureFlag[] = [];

  constructor(
    private adminService: AdminService,
    private dialog: MatDialog,
  ) {}

  ngOnInit() {
    this.loadFeatureFlags();
  }

  loadFeatureFlags() {
    this.loading = true;
    this.adminService.getFeatureFlags().then((featureFlags) => {
      this.featureFlags = featureFlags;
    }).finally(() => this.loading = false);
  }

  create() {
    this.loading = true;

    const dialogRef = this.dialog.open<SimpleDialogComponent, SimpleDialogData, string | null>(
      SimpleDialogComponent,
      {
        data: {
          new: false,
          name: '',
          title: 'Create Feature Flag',
          label: 'Feature Flag Name',
          submitText: 'Create',
          required: true,
        },
      }
    );

    dialogRef.afterClosed().subscribe((result) => {
      if (!!result) {
        this.adminService.createFeatureFlag(result.trim()).then((featureFlags) => {
          this.featureFlags = featureFlags;
        })
        .finally(() => {
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });

  }

  toggle(featureFlag: FeatureFlag) {
    this.loading = true;
    this.adminService
      .updateFeatureFlag(featureFlag.id, featureFlag.name, !featureFlag.enabled)
      .then((featureFlags) => {
        this.featureFlags = featureFlags;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  delete(featureFlag: FeatureFlag) {
    if (confirm(`Are you sure you want to delete feature flag ${featureFlag.name}?`)) {
      this.loading = true;
      this.adminService
        .deleteFeatureFlag(featureFlag.id)
        .then((featureFlags) => {
          this.featureFlags = featureFlags;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
}
